module.exports = __webpack_public_path__ + "static/media/favoriteHeartIcon.e1e5a293.svg";